import { render, staticRenderFns } from "./HelpFormLayout.vue?vue&type=template&id=2a52b5fe&scoped=true"
import script from "./HelpFormLayout.vue?vue&type=script&lang=js"
export * from "./HelpFormLayout.vue?vue&type=script&lang=js"
import style0 from "./HelpFormLayout.vue?vue&type=style&index=0&id=2a52b5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52b5fe",
  null
  
)

export default component.exports